import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";
import GTCSettings from "../../containers/GTCSettings/GTCSettings";
import GTCBackground from "../GTCBackground/GTCBackground";
import GTCNavigation from "../GTCNavigation/GTCNavigation";
import Footer from "../UI/Footer/Footer";

const GTCLayout = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `NVIDIA | ${t("GRANT PERMISSION")}`;
  });
  const locale = props.locale;
  return (
    <>
      <GTCBackground />
      <GTCNavigation />
      <Route
        path="/gtc/:serviceType/:version?"
        render={(props) => {
          return <GTCSettings {...props} locale={locale} />;
        }}
      />
      <Footer locale={locale} />
    </>
  );
};

export default GTCLayout;
